<template>
  <el-dialog :visible.sync="dialogVisibleValue" @close="closeDialog" width="900px"
             :close-on-click-modal="false"
             title="收入">
    <div class='dialogBody'>
      <el-row :gutter="20" type='flex' justify='center' style='margin: 20px 0'>
        <el-col :span='6' class='spanCol'>
          <span>现有资产规模：</span>
        </el-col>
        <el-col :span='18'>
          <el-input v-model='alreadyScaleSaving' size='small'></el-input>
        </el-col>
      </el-row>
      <el-row :gutter="20" style='margin: 20px 0'>
        <el-col :span='6' class='spanCol'>
          <span>税前工资收入：</span>
        </el-col>
        <el-col :span='4'>
          <el-select v-model="preTaxCycle" size='small'>
            <el-option v-for="item in cycleOptions" :key="item.value" :label="item.label" :value="item.value"> </el-option>
          </el-select>
        </el-col>
        <el-col :span='14'>
          <el-input v-model='preTaxIncome' size='small'></el-input>
        </el-col>
      </el-row>
      <el-row :gutter="20" style='margin: 20px 0'>
        <el-col :span='6' class='spanCol'>
          <span>其他收入：</span>
        </el-col>
        <el-col :span='4'>
          <el-select v-model="preTaxCycle" size='small'>
            <el-option v-for="item in cycleOptions" :key="item.value" :label="item.label" :value="item.value"> </el-option>
          </el-select>
        </el-col>
        <el-col :span='14'>
          <el-input v-model='otherIncome' size='small'></el-input>
        </el-col>
      </el-row>
    </div>
    <div slot="footer">
      <el-button type="primary" @click="confirm">确 定</el-button>
    </div>
  </el-dialog>
</template>

<script>
export default {
  name: 'IncomeDialog',
  props: ['dialogVisible', 'params'],
  watch: {
    dialogVisible (val) {
      this.dialogVisibleValue = val
      if (val) {
        this.alreadyScaleSaving = this.params["EXISTING_SAVINGS_AMOUNT"]
        this.preTaxIncome = this.preTaxCycle === 'month' ? this.params["INCOME_SUBJECT_TO_TAXATION"] : this.params["INCOME_SUBJECT_TO_TAXATION"] * 12
        this.otherIncome = this.otherCycle === 'month' ? this.params["OTHER_INCOMES"] : this.params["OTHER_INCOMES"] * 12
      }
    }
  },
  data() {
    return {
      blockIndex: 0,
      dialogVisibleValue: false,
      alreadyScaleSaving: 0,
      preTaxIncome: 0,
      preTaxCycle: 'month',
      otherIncome: 0,
      otherCycle: 'month',
      cycleOptions: [{label: '月度', value: 'month'}, {label: '年度', value: 'year'}]
    }
  },
  methods: {
    confirm () {
      const data = {
        "EXISTING_SAVINGS_AMOUNT": this.alreadyScaleSaving,
        "INCOME_SUBJECT_TO_TAXATION": this.preTaxCycle === 'month' ? this.preTaxIncome : this.preTaxIncome / 12,
        "OTHER_INCOMES": this.otherCycle === 'month' ? this.otherIncome : this.otherIncome /12
      }
      this.$emit('incomeDialogConfirm', data)
      this.closeDialog()
    },
    closeDialog () {
      this.dialogVisibleValue = false
      this.$emit('dialogVisibleChange', this.dialogVisibleValue)
    },
  }
}
</script>

<style scoped>
.dialogBody {
  max-height: 460px;
  overflow-y: auto;
  font-size: 18px;
}
.spanCol {
  /*text-align: right;*/
}
</style>



// WEBPACK FOOTER //
// src/components/options/IncomeDialog.vue